import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectBox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      selected: props.selected,
      data: props.data,
      model: props.model,
      url: props.url,
      placeholder: props.placeholder,
      isLoading: true,
    };
  }

  componentDidMount() {
  }

  renderSelectBox() {
    const account = this.state.account;
    const selected = this.state.selected;
    const data = this.state.data;
    const model = this.state.model;
    const url = this.state.url;
    const placeholder = this.state.placeholder;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        selected: value,
      });
      if (value) {
        document.getElementById(`${model}_id`).value = value.id;
      } else {
        document.getElementById(`${model}_id`).value = null;
      }
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/${url}/select?search=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={data}
        placeholder={placeholder}
        value={selected}
        getOptionLabel={c => c.title}
        getOptionValue={c => c.id}
        loadOptions={loadOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        isClearable
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectBox()}
      </div>
    );
  }
}

SelectBox.propTypes = {
  account: PropTypes.object,
  selected: PropTypes.object,
  data: PropTypes.array,
  model: PropTypes.string,
  url: PropTypes.string,
  placeholder: PropTypes.string,
};

export default SelectBox;
